import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getLocationOrigin } from '@api/utils/url-helpers';
import * as thresholdActions from '../../store/actions/actions';
import { Store } from '@ngrx/store';

declare var window: any;

@Component({
    template: '<p>Please wait...</p>'
})

export class UserProfileSwitchRedirectComponent {
    private oidc: any;

    constructor(private store: Store<any>, private route: ActivatedRoute) { 

		this.oidc = window._oidc;
		this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));

		setTimeout(() => {
			this.store.dispatch( new thresholdActions.SetBannerTitleAction('Loading your profile') );
			this.store.dispatch( new thresholdActions.SetApplicationTitleAction("Access") );
			this.store.dispatch( new thresholdActions.ShowBannerAction() );
			this.store.dispatch( new thresholdActions.SetColorAction('#fff') );
			this.store.dispatch( new thresholdActions.SetVariantAction('jumbo-variant-dark') );
			this.store.dispatch( new thresholdActions.SetBannerBackgroundAction('') );
			this.store.dispatch( new thresholdActions.SetSizeAction('sol-jumbo-h1') );
			this.store.dispatch( new thresholdActions.HideContextNavAction() );
			this.store.dispatch( new thresholdActions.HideMenuAction() );
			this.store.dispatch( new thresholdActions.HideMainMenuAction() );
			this.store.dispatch( new thresholdActions.HideProfileBannerAction() );
			this.store.dispatch( new thresholdActions.SetDynamicMenuAction([]));
		});

        this.route.params.subscribe(params => {
            const userProfileId = params['userProfileId'];
			const responseType = JSON.parse(window['__CONFIGURATION'])['responseType'];
			const scope = JSON.parse(window['__CONFIGURATION'])['scopes'];	

			const redirectSigninRequest = {
				response_type: responseType,
				scope: scope,
				redirect_uri: `${window.location.protocol}//${window.location.host}/auth-callback.html`,
				login_hint: userProfileId,
				prompt: 'login'
			}

			this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
			
			setTimeout(() => {
				this.oidc.createSigninRequest(redirectSigninRequest).then(signinRequest => {
					let auth = JSON.parse(window['__CONFIGURATION'])['authUrl'];
					if (signinRequest.url.includes(auth)) {	
						this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
						window.location.href = signinRequest.url;
					}
				});
			}, 2000);
        });
    }    
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/user/user-profile-switch-redirect.component.ts